import { ActivityFilterType } from 'generated/graphql'
import { ActivityTypeID } from 'constants/enums'

export interface FilterTypeWithName {
  filterType: ActivityFilterType
  name: string
}
export const filterTypesByActivityTypeID: {
  [key in ActivityTypeID]: Array<FilterTypeWithName>
} = {
  [ActivityTypeID.ACTIVITY]: [
    { filterType: ActivityFilterType.CATEGORY, name: '활동분야' },
    { filterType: ActivityFilterType.INTEREST, name: '관심분야' },
    { filterType: ActivityFilterType.BENEFIT, name: '활동혜택' },
    { filterType: ActivityFilterType.PERIOD, name: '활동기간' },
    { filterType: ActivityFilterType.REGION, name: '모임지역' },
    { filterType: ActivityFilterType.ORGANIZATION, name: '주최기관' },
  ],
  [ActivityTypeID.CLUB]: [
    { filterType: ActivityFilterType.CATEGORY, name: '활동분야' },
    { filterType: ActivityFilterType.INTEREST, name: '관심분야' },
    { filterType: ActivityFilterType.REGION, name: '모임지역' },
    { filterType: ActivityFilterType.TARGET, name: '모임대상' },
  ],
  [ActivityTypeID.CONTEST]: [
    { filterType: ActivityFilterType.CATEGORY, name: '공모분야' },
    { filterType: ActivityFilterType.PRIZE, name: '시상규모' },
    { filterType: ActivityFilterType.BENEFIT, name: '수상혜택' },
    { filterType: ActivityFilterType.TARGET, name: '응모대상' },
    { filterType: ActivityFilterType.ORGANIZATION, name: '주최기관' },
  ],
  [ActivityTypeID.RECRUIT]: [],
  [ActivityTypeID.INTERN]: [],
  [ActivityTypeID.EDUCATION]: [],
}

export const fieldNameByActivityFilterType: {
  [key in ActivityFilterType]:
    | 'categoryIDs'
    | 'interestIDs'
    | 'period'
    | 'regionIDs'
    | 'benefitIDs'
    | 'organizationTypes'
    | 'reward'
    | 'targetIDs'
} = {
  [ActivityFilterType.CATEGORY]: 'categoryIDs',
  [ActivityFilterType.INTEREST]: 'interestIDs',
  [ActivityFilterType.PERIOD]: 'period',
  [ActivityFilterType.REGION]: 'regionIDs',
  [ActivityFilterType.BENEFIT]: 'benefitIDs',
  [ActivityFilterType.ORGANIZATION]: 'organizationTypes',
  [ActivityFilterType.PRIZE]: 'reward',
  [ActivityFilterType.TARGET]: 'targetIDs',
}

export const PAGE_SIZE = 20
